import * as tslib_1 from "tslib";
import { AuthenticationService } from '@core/authentication/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment-timezone';
import { CreateRecurrenceLinkLogsService } from './create-recurrence-link-logs.service';
import { UpdatedByLogService } from './updated-by-log.service';
import * as i0 from "@angular/core";
import * as i1 from "./updated-by-log.service";
import * as i2 from "@ngx-translate/core";
import * as i3 from "../../../../../../core/authentication/authentication.service";
import * as i4 from "./create-recurrence-link-logs.service";
var CreateRecurrenceLogsService = /** @class */ (function () {
    function CreateRecurrenceLogsService(updatedByLog, translateService, authenticationService, createRecurrenceLinkLogsService) {
        this.updatedByLog = updatedByLog;
        this.translateService = translateService;
        this.authenticationService = authenticationService;
        this.createRecurrenceLinkLogsService = createRecurrenceLinkLogsService;
        this.recurrenceLogsMapped = [];
    }
    CreateRecurrenceLogsService.prototype.listRecurrenceLogsMapped = function (recurrence) {
        var _this = this;
        this.recurrenceLogsMapped = [];
        recurrence.logs.forEach(function (currentLog, index) {
            var previousLog = recurrence.logs[index - 1];
            var log = tslib_1.__assign({}, currentLog, { icon: 'ic_plus_20px', eventDescription: null, eventName: _this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.EVENTS.CREATED'), colorClass: 'light-purple', formattedCreatedAt: moment(currentLog.createdAt).local().format('DD/MM/YYYY'), createdAt: moment(currentLog.createdAt).local().format('DD/MM/YYYY HH:mm:ss'), showMessage: false, showLinks: false });
            if (!previousLog) {
                return _this.generateCreatedLog({ log: log });
            }
            var hasChangedEquipments = JSON.stringify(currentLog.snapshot.equipments || []) !== JSON.stringify(previousLog.snapshot.equipments || []);
            var hasChangedLocationSectors = JSON.stringify(currentLog.snapshot.locationSectors || []) !== JSON.stringify(previousLog.snapshot.locationSectors || []);
            var hasChangedLocationEnvironments = JSON.stringify(currentLog.snapshot.locationEnvironments || []) !== JSON.stringify(previousLog.snapshot.locationEnvironments || []);
            var hasChangedLinks = hasChangedLocationSectors || hasChangedLocationEnvironments || hasChangedEquipments;
            if (hasChangedLinks) {
                _this.generateLinksLog({ log: log });
            }
            if (currentLog.snapshot.archived !== previousLog.snapshot.archived) {
                _this.generateArchiveOrUnarchiveLog({ log: log });
            }
            if (currentLog.snapshot.message !== previousLog.snapshot.message) {
                _this.generateMessageLog({ log: log });
            }
            if (currentLog.snapshot.location.id !== previousLog.snapshot.location.id) {
                _this.generateLocationLog({ log: log, previousLog: previousLog });
            }
        });
        var recurrencesLogsWithUpdatedBy = this.updatedByLog.customUpdatedByInLogs(this.recurrenceLogsMapped);
        return recurrencesLogsWithUpdatedBy.reverse();
    };
    CreateRecurrenceLogsService.prototype.generateCreatedLog = function (_a) {
        var log = _a.log;
        this.recurrenceLogsMapped.push(tslib_1.__assign({}, log, { isCreatedLog: true, showMessage: true, showLinks: true, links: this.createRecurrenceLinkLogsService.generateLinks(log.snapshot) }));
    };
    CreateRecurrenceLogsService.prototype.generateLinksLog = function (_a) {
        var log = _a.log;
        log.eventName = this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.EVENTS.LINKS_UPDATED');
        log.icon = 'ic_links';
        log.colorClass = 'brown';
        var links = this.createRecurrenceLinkLogsService.generateLinks(log.snapshot);
        this.recurrenceLogsMapped.push(tslib_1.__assign({}, log, { links: links, showLinks: true }));
    };
    CreateRecurrenceLogsService.prototype.generateArchiveOrUnarchiveLog = function (_a) {
        var log = _a.log;
        if (log.snapshot.archived) {
            log.eventName = this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.EVENTS.ARCHIVED');
            log.icon = 'ic_archive_18px';
            log.colorClass = 'light-gray';
        }
        else {
            log.eventName = this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.EVENTS.UNARCHIVED');
            log.icon = 'ic_unarchive_18px';
            log.colorClass = 'dark-gray';
        }
        this.recurrenceLogsMapped.push(log);
    };
    CreateRecurrenceLogsService.prototype.generateMessageLog = function (_a) {
        var log = _a.log;
        log.eventName = this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.EVENTS.DESCRIPTION_UPDATED');
        log.icon = 'ic_chat_20px';
        log.colorClass = 'gray';
        this.recurrenceLogsMapped.push(tslib_1.__assign({}, log, { showMessage: true }));
    };
    CreateRecurrenceLogsService.prototype.generateLocationLog = function (_a) {
        var log = _a.log, previousLog = _a.previousLog;
        log.icon = 'ic_location_18px';
        log.colorClass = 'blue';
        log.eventName = this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.EVENTS.LOCATION_UPDATED');
        log.eventDescription = this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.EVENTS.LOCATION_DESCRIPTION', {
            previousLocation: previousLog.snapshot.location.name,
            currentLocation: log.snapshot.location.name
        });
        this.recurrenceLogsMapped.push(log);
    };
    CreateRecurrenceLogsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CreateRecurrenceLogsService_Factory() { return new CreateRecurrenceLogsService(i0.ɵɵinject(i1.UpdatedByLogService), i0.ɵɵinject(i2.TranslateService), i0.ɵɵinject(i3.AuthenticationService), i0.ɵɵinject(i4.CreateRecurrenceLinkLogsService)); }, token: CreateRecurrenceLogsService, providedIn: "root" });
    return CreateRecurrenceLogsService;
}());
export { CreateRecurrenceLogsService };
